// extracted by mini-css-extract-plugin
export default {"container":"SubmitResponse_container__NkTDU","containerError":"SubmitResponse_containerError__nGLkB","error":"SubmitResponse_error__GeLHa"};